<template>
  <v-flex xs12 sm12 d-block class="card-dados card-dados__mobile">
    <h3 class="card-dados__titulo mb-0">Todos os Itens</h3>

    <v-data-table :headers="colunas" :items="value" hide-actions
                  class="az-table-list tabela-todos-lotes"
                  no-data-text="Não há registro disponível">
      <template slot="items" slot-scope="props">
        <tr>
          <td class="text-uppercase">
            {{ props.item.loteItem }}
          </td>
          <td>
            <ver-mais :tamanho="tamanho" :descricao="props.item.descricao"
                      :itens="props.item.itens"/>
          </td>
          <td>
            <div class="ranking" 
                 :class="{'desclassificado': empresa.situacao === 'DESCLASSIFICADO' || empresa.situacao === 'INABILITADO'}" 
                 v-for="empresa in props.item.ranking" 
                 :key="empresa.posicao">
              <p>
                {{ empresa.razaoSocial }}
              </p>
              <p>
                Valor: {{empresa.valorTotal | cdCurrency(prefix, casasDecimais)}}{{suffix}}
              </p>
              <small v-if="empresa.situacao === 'DESCLASSIFICADO'">
                <v-tooltip top v-if="empresa.motivo" class="botao-motivo">
                  <a slot="activator">
                    (DESCLASSIFICADO)&nbsp;
                    <i class="fas fa-comment" aria-hidden="true"/>
                  </a>
                  {{ empresa.motivo }}
                </v-tooltip>
              </small>
              <small v-if="empresa.situacao === 'INABILITADO'">
                <v-tooltip top v-if="empresa.motivo" class="botao-motivo">
                  <a slot="activator">
                    (INABILITADO)&nbsp;
                    <i class="fas fa-comment" aria-hidden="true"/>
                  </a>
                  {{ empresa.motivo }}
                </v-tooltip>
              </small>
            </div>
          </td>
          <td>
            <div class="ranking" v-if="props.item.vencedor">
              <p>
                {{ props.item.vencedor.razaoSocial }}
              </p>
              <p>
                Valor: {{props.item.vencedor.valorTotal | cdCurrency(prefix, casasDecimais)}}{{suffix}}
              </p>
            </div>
          </td>
          <td align="right">
                        <span class="situacao-adjudicado" v-if="props.item.situacao === 'ADJUDICADO'">
                            <i class="fas fa-check mr-1" aria-hidden="true"/> Adjudicado
                        </span>
            <div v-else>
              <v-tooltip top v-if="props.item.motivo" class="botao-motivo">
                <a slot="activator">
                  {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                  <i class="fas fa-comment" aria-hidden="true"/>
                </a>
                {{ props.item.motivo }}
              </v-tooltip>
              <span v-else>
                                {{ props.item.situacao | azEnum(situacoesItensELotes) }}
                            </span>
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-flex>
</template>

<script>
import {mapState} from 'vuex'
import VerMais from '@/views/components/VerMais'
import ExpansaoTexto from '@/views/components/ExpansaoTexto'

export default {
    name: 'TodosLotesItens',
    components: {
        VerMais,
        ExpansaoTexto
    },
    data() {
        return {
            colunas: [
                {
                    align: 'left',
                    sortable: true,
                    width: '10px',
                    class: 'primary--text',
                    text: 'Seq',
                    value: 'loteItem'
                },
                {
                    align: 'left',
                    value: 'descricao',
                    class: 'primary--text',
                    text: 'Descrição',
                    width: '150px',
                    sortable: false
                },
                {
                    sortable: false,
                    text: 'Participantes',
                    align: 'left',
                    width: '125px',
                    value: 'ranking',
                    class: 'primary--text'
                },                    {
                    sortable: false,
                    text: 'Vencedor',
                    align: 'left',
                    width: '125px',
                    value: 'vencedor',
                    class: 'primary--text'
                },
                {
                    sortable: false,
                    text: 'Situação',
                    align: 'right',
                    width: '60px',
                    value: 'situacao',
                    class: 'primary--text'
                }
            ],
            situacoesItensELotes: {
                ADJUDICADO: 'Adjudicado',
                AGUARDANDO_ANALISE: 'Aguardando Análise',
                CLASSIFICADO: 'Classificado',
                ANULADO: 'Anulado',
                CANCELADO: 'Cancelado',
                DESERTO: 'Deserto',
                EM_ANDAMENTO: 'Em Andamento',
                EM_ELABORACAO: 'Em Elaboração',
                FRACASSADO: 'Fracassado',
                REVOGADO: 'Revogado'
            },
            tamanho: null
        }
    },
    props: {
        value: {
            type: Array,
            required: true,
            default: () => {
                return []
            }
        },
        casasDecimais: {
            type: Number,
            default: 2
        },
        criterioJulgamento:{
            type: String
        },
        validarLancesPor:{
            type: String
        },
        prefixSuffixValor:{
            type: String
        },
        placeHolderValorOuDesconto:{
            type: String
        }
    },
    computed: {
        ...mapState(['loki']),
        prefix(){
            return this.prefixSuffixValor === 'R$' ? 'R$ ' : ''
        },
        suffix(){
            return this.prefixSuffixValor === '%' ? '%' : ''
        }
    },
    created() {
        window.addEventListener('resize', this.pegarTamanho)
        this.pegarTamanho()
    },
    methods: {
        pegarTamanho() {
            this.tamanho = .2 * window.innerWidth
        }
    },
    destroyed() {
        window.removeEventListener('resize', this.pegarTamanho)
    }
}
</script>

<style scoped lang="stylus">
.tabela-todos-lotes
  padding 16px

  .ranking
    margin-bottom .5rem

    p
      margin-bottom 0

.desclassificado p
  text-decoration line-through

@media (max-width 720px)
  .tabela-todos-lotes
    padding 0

  td:nth-of-type(5)
    text-align left
</style>
